// extracted by mini-css-extract-plugin
export default {"accept-drop":"_1F_2Z","acceptDrop":"_1F_2Z","reject-drop":"_3Yp18","rejectDrop":"_3Yp18"};